import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import { canManageLateSubmissionPolicies } from '@/policies/LateSubmissionPolicyPolicy.js';

const meta = {
    title: 'Late Submission Policies',
    middleware: [GateKeeperMiddleware],
    ability: ({ gateKeeper }) => canManageLateSubmissionPolicies(gateKeeper.user),
    dataTablePage: true,
};

export default [
    {
        path: '/administration/late-submission-policies',
        name: 'late-submission-policies-index',
        component: () => import('@/pages/administration/late-submission-policies/PolicyIndex.vue'),
        meta: { ...meta },
        beforeEnter: FeatureMiddleware('LATE_SUBMISSION_POLICIES'),
    },
    {
        path: '/administration/late-submission-policies/:policyId',
        name: 'late-submission-policies-show',
        component: () => import('@/pages/administration/late-submission-policies/PolicyDetail.vue'),
        meta: { ...meta, title: 'Late Submission Policy' },
        beforeEnter: FeatureMiddleware('LATE_SUBMISSION_POLICIES'),
        props: true,
    },
];
